import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { Ornament } from '@/components/generals/ornament'
import { ButtonLink } from '@/components/generals/button'

export const ConsultationBand: FC = (): ReactNode => {
    return (
        <section id='consultation' aria-labelledby='consultation-title' className='relative isolate overflow-hidden bg-maroon-deep text-ivory'>
            <Image
                src='/images/lights.jpg'
                alt=''
                fill
                sizes='100vw'
                className='-z-20 object-cover opacity-40 mix-blend-luminosity'
            />

            <div aria-hidden='true' className='absolute inset-0 -z-10 bg-gradient-to-b from-maroon-deep/80 via-maroon/85 to-maroon-deep/95' />
            <div aria-hidden='true' className='toran absolute inset-x-0 top-0' />

            <div className='mx-auto max-w-4xl px-5 py-24 text-center sm:px-8 lg:py-32'>
                <Ornament className='mx-auto text-gold-light' />

                <h2 id='consultation-title' className='mt-7 text-4xl leading-[1.08] sm:text-5xl lg:text-6xl'>
                    Let's plan a wedding your families will talk about for years
                </h2>

                <p className='mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-ivory/80'>
                    Tell us a little about your plans. We reply within two working days with a few questions and a time for your free consultation.
                </p>

                <div className='mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row'>
                    <ButtonLink href='/contact' variant='secondary' size='lg'>
                        Book a free consultation
                    </ButtonLink>

                    <ButtonLink href='/services' variant='outlineLight' size='lg'>
                        Explore our services
                    </ButtonLink>
                </div>
            </div>
        </section>
    )
}
